import React, { useEffect, useRef, useState } from "react";
import "../../styles/AboutSection/ScrollIndicator.scss";
import { Box, Typography } from "@mui/material";
import { Swiper as SwiperClass } from "swiper/swiper"; // Import Swiper type
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import i18next from "i18next";
interface Card {
  id: string;
  title: string;
  subtitle: string;
}

interface ScrollIndicatorProps {
  cards: Card[];
}

const HorizontalList: React.FC<ScrollIndicatorProps> = ({ cards }) => {
  const swiperRef = useRef<SwiperClass | null>(null);

  if (!cards || cards.length === 0) {
    return <div>No cards available</div>;
  }

  return (
    <Box
      sx={{
        width: { sm: "90vw", md: "100vw", xs: "90vw" },
      }}
    >
      <Swiper
        loop={true}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        modules={[Navigation, Autoplay]}
        onSwiper={(swiper: SwiperClass) => (swiperRef.current = swiper)}
        breakpoints={{
          0: { slidesPerView: 1 }, // Mobile - 1 card
          600: { slidesPerView: 1 }, // Small screens - 1 card
          900: { slidesPerView: 2 }, // Tablets - 2 cards
          1200: { slidesPerView: 3 }, // Laptops - 3 cards
        }}
      >
        {cards.map((card, index) => (
          <SwiperSlide key={card.id} className="swiper-slide">
            <Typography
              fontFamily={i18next.language === "ar" ? "Somar" : "DM Sans"}
              mt={".5rem"}
              ml={".2rem"}
              align="justify"
              fontSize={"1rem"}
              fontWeight={"500"}
            >
              {card.title}
            </Typography>
            <Typography
              fontFamily={i18next.language === "ar" ? "Somar" : "DM Sans"}
              ml={".2rem"}
              align="justify"
              fontWeight={"400"}
            >
              {card.subtitle}
            </Typography>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};

export default HorizontalList;
